import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ChecklistDisplayItem, ChecklistItemDecision } from '@core/models';
import { ChecklistCategoryStepComponent } from '../checklist-category-step/checklist-category-step.component';

@Component({
  selector: 'app-checklist-panel',
  imports: [CommonModule, ChecklistCategoryStepComponent],
  templateUrl: './checklist-panel.component.html',
  styleUrl: './checklist-panel.component.scss',
})
export class ChecklistPanelComponent {
  @ViewChild('stepsNav') private readonly stepsNav?: ElementRef<HTMLElement>;

  @Input({ required: true }) categories: Array<[string, ChecklistDisplayItem[]]> = [];
  @Input({ required: true }) activeStep = 0;
  @Input({ required: true }) decisions: Record<string, ChecklistItemDecision> = {};
  @Input() validationErrors: string[] = [];
  @Input() emptyMessage = 'La orden no incluye checklist inicial.';

  @Output() stepChange = new EventEmitter<number>();
  @Output() decisionChange = new EventEmitter<{
    itemId: string;
    patch: Partial<ChecklistItemDecision>;
  }>();

  scrollSteps(direction: 'previous' | 'next'): void {
    const nav = this.stepsNav?.nativeElement;

    if (!nav) {
      return;
    }

    const distance = nav.clientWidth * 0.75;

    nav.scrollBy({
      left: direction === 'next' ? distance : -distance,
      behavior: 'smooth',
    });
  }
}
